<form [formGroup]="form">
  <nz-select [formControl]="form.controls.language">
    @for (language of languages; track language?.value) {
      <nz-option
        [nzValue]="language?.value"
        [nzLabel]="language?.code | translate"
      />
    }
  </nz-select>
</form>
